import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Spinner } from "flowbite-react";

const MESSAGES = {
  loading: "Preparando acesso...",
  success: "Acesso liberado! Redirecionando...",
  error: "Não foi possível concluir a personificação.",
};

const cleanToken = (value) => {
  if (!value) return "";
  return String(value).replace(/^Bearer\s+/i, "").trim();
};

const ImpersonatePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState("");

  useEffect(() => {
    const tokenParam = params.get("token");
    const token = cleanToken(tokenParam);
    if (!token) {
      setStatus("error");
      setDetails("Token ausente ou inválido.");
      return;
    }

    try {
      localStorage.setItem("token", token);
      setStatus("success");
      const timer = setTimeout(() => {
        navigate("/", { replace: true });
      }, 600);
      return () => clearTimeout(timer);
    } catch (err) {
      setStatus("error");
      setDetails("Não foi possível salvar o token de acesso.");
    }
  }, [navigate, params]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
          Personificação
        </p>
        <h1 className="mt-4 text-xl font-semibold">{MESSAGES[status]}</h1>
        {details && <p className="mt-3 text-sm text-slate-500">{details}</p>}
        {status === "loading" && (
          <div className="mt-4 flex justify-center">
            <Spinner size="lg" />
          </div>
        )}
        {status === "error" && (
          <div className="mt-6 flex justify-center">
            <Button color="gray" onClick={() => navigate("/login")}>
              Ir para login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImpersonatePage;
